import { Action, createReducer, on } from '@ngrx/store';
import { PATCH_INATTIVITA_CLUSTER_SUCCESS } from './cluster.actions';
import { IResponseCluster } from '../../interfaces/cluster';
import { IClusterState } from "./cluster";

//139172 – Tool per la rilevazione stato del PuntoPoste
export const initialState: IClusterState = {
    operationCluster: null,
};

const handleOperationCluster = (
    state: IClusterState,
    { operationCluster }: { operationCluster: IResponseCluster | null }
  ): IClusterState => {
    return {
      ...state,
      operationCluster
    };
  };

export const reducer = createReducer(
    initialState,
    on(PATCH_INATTIVITA_CLUSTER_SUCCESS, handleOperationCluster)
);

export const clusterReducer = (
    state: IClusterState | undefined,
    action: Action
): IClusterState => reducer(state, action);
  